/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductionMaterialType } from "./ProductionMaterialType";
import { ProductType } from "./ProductType";

export class TextureMaterialDto {
    id: string;
    name: string;
    textureUrl: string;
    normalMapUrl: string;
    displacementMapUrl: string;
    productionMaterialType: ProductionMaterialType;
    productType: ProductType;
    specification: Object;
}
